

import React, { useEffect, useRef, useState } from 'react';
import '../../Assets/CSS/profile.css';
import profileimg from '../../Assets/Images/profile/profile.jpeg';
import { Icon } from '@iconify/react';
import axios from 'axios';
import toast, { Toaster } from 'react-hot-toast';
import { useNavigate } from 'react-router-dom';
import uploadImagetos3 from '../../UplaodToS3';
import { getCookie } from '../../components/auth/login/GetCookie';
const EditProfile = ({ initialProfileImg ,setActiveTab }) => {
    const [showPasswordFields, setShowPasswordFields] = useState(false);
    const [showPassword, setShowPassword] = useState(false);
    const [showNewPassword, setShowNewPassword] = useState(false);
    const [newEmail, setNewEmail] = useState(null);
    const [newPhoneNumber, setNewPhoneNumber] = useState(null);
    const [showConfirmPassword, setShowConfirmPassword] = useState(false);
    const [profileImg, setProfileImg] = useState(initialProfileImg || "");
    const[fileupload,setFileUpload]=useState(null);
    const [showConfirmationModal, setShowConfirmationModal] = useState(false);
    const fileInputRef = useRef(null);
 
    const [profileInfo, setProfileInfo] = useState({});

    const [formData, setFormData] = useState({
        firstName:profileInfo.firstName,
        lastName:profileInfo.lastName,
        countryName:profileInfo.countryName,
        countryCode:profileInfo.countryCode,
        mobileNumber:profileInfo.mobileNumber,
        email:profileInfo.email,
        emailVerificationToken: null,
        mobileVerificationToken:null,
currentPassword:profileInfo.currentPassword,
newPassword:profileInfo.newPassword,
confirmPassword:profileInfo.confirmPassword,
      });
    const [newPassword, setNewPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');
    const [passwordError, setPasswordError] = useState('');
    
 const navigate = useNavigate();
    
    const [emailVerified, setEmailVerified] = useState(false);
    const [phoneVerified, setPhoneVerified] = useState(profileInfo.mobileNumberVerified == 'true'? true :false);
    const [emailOtp, setEmailOtp] = useState(null);
    const [phoneOtp, setPhoneOtp] = useState(null);
    const [emailTimer, setEmailTimer] = useState(0);
    const [phoneTimer, setPhoneTimer] = useState(0);
    const [showEmailOtpInput, setShowEmailOtpInput] = useState(false);
    const [showPhoneOtpInput, setShowPhoneOtpInput] = useState(false);
    const API_URL = process.env.REACT_APP_BACKEND_URL;
    useEffect(() => {

        fetchProfile();
    }, []); // Runs only once when the component mounts
    const fetchProfile = async () => {
        try {
            
            // const token = localStorage.getItem('token');
            const token = getCookie("token");
            const response = await fetch(`${API_URL}/api/v1/users/my-profile`, {
                method: "GET",
                headers: {
                    "Accept": "*/*",
                    "Authorization": `Bearer ${token}`
                }
            });

            if (!response.ok) {
                throw new Error(`HTTP error! Status: ${response.status}`);
            }

            const data = await response.json();
            setProfileInfo(data);
            setProfileImg(data.profileImageUrl)
            setEmailVerified(data.emailVerified);
            setPhoneVerified(data.mobileNumberVerified);
        } catch (error) {
            console.error("Error fetching profile:", error);
        }
    };
    useEffect(() => {
        let emailInterval, phoneInterval;
        if (emailTimer > 0) {
            emailInterval = setInterval(() => {
                setEmailTimer((prev) => prev - 1);
            }, 1000);
        }
        if (phoneTimer > 0) {
            phoneInterval = setInterval(() => {
                setPhoneTimer((prev) => prev - 1);
            }, 1000);
        }
        return () => {
            clearInterval(emailInterval);
            clearInterval(phoneInterval);
        };
    }, [emailTimer, phoneTimer]);

    const handleEditClick = () => {
        fileInputRef.current.click();
    };

    const handleChangePassword = () => {
        setShowPasswordFields(!showPasswordFields);
    };

    const handleImageChange = (e) => {
        const file =e.target.files[0];
        if(file)
        {
          // validate file type
          const allowedTypes =['image/jpeg','image/png','image/jpg'];
          if(!allowedTypes.includes(file.type))
          {
            toast.error('Only JPG,JPEG,and PNG file are allowed.');
            return;
          }
          // validate file size 
          const maxSize = 5*1024 *1024;
          if(file.size>maxSize)
          {
            toast.error('file size should be less than 5MB.')
            return;
          }
          setFileUpload(file);
          setProfileImg(URL.createObjectURL(file));
         console.log(profileImg);
         
        }
    };

    // const handlePasswordChange = async () => {
    //     if (newPassword !== confirmPassword) {
    //         setPasswordError('Passwords do not match');
    //         return;
    //     }
    //     setPasswordError();
    //     try {
    //         const response = await axios.post(`${API_URL}/api/v1/forgot-password/change-password`, {
    //             email: profileInfo.email,
    //             newPassword: newPassword,
    //             confimNewPassword: confirmPassword
    //         });

    //         if (response.status === 200) {
    //             toast.success('Password changed successfully');
    //         } else {
    //             toast.error('Failed to change password');
    //         }
    //     } catch (error) {
    //         toast.error('Failed to change password');
    //     }
    // };
    const handlePhoneNumberChange = (e) => {
        setNewPhoneNumber(e.target.value);
        setPhoneVerified(false);
        // setProfileInfo({ ...profileInfo, mobileNumber: e.target.value });
    };

    const handleEmailChange = (e) => {
        setNewEmail(e.target.value);
        setEmailVerified(false);
        // setProfileInfo({ ...profileInfo, email: e.target.value });
    };

    const handleEmailBlur = (e) => {
        if (e.target.value == profileInfo.email && profileInfo.email == newEmail ) {
            setEmailVerified(profileInfo.emailVerified);
        }

        // setProfileInfo({ ...profileInfo, email: e.target.value });
    };

    const handlePhoneNumberBlur = (e) => {
        if (e.target.value == profileInfo.mobileNumber && profileInfo.mobileNumber == newPhoneNumber ) {
            setPhoneVerified(profileInfo.mobileNumberVerified);
        }
        if (!e.target.value) {
            setNewPhoneNumber(null)
            setPhoneVerified(profileInfo.mobileNumberVerified);
        }
        // setProfileInfo({ ...profileInfo, email: e.target.value });
    };
    const handleVerifyEmail= async () => {
        try {
            const response = await axios.post(`${API_URL}/api/v1/auth/validate-email`, {
                email: newEmail,
            });

            if (response.status === 200) {
                
                
                toast.success("OTP has been sent on Email Id: " + profileInfo.email);
                setEmailTimer(16);
                setShowEmailOtpInput(true);
            } else {
                toast.error('Failed to verify phone number');
            }
        } catch (error) {
            toast.error(error);
        }
    };
    const handleVerifyPhoneNumber = async () => {
        try {
            const response = await axios.post(`${API_URL}/api/v1/auth/validate-mobile-number`, {
                countryCode: profileInfo.countryCode,
                mobileNumber: newPhoneNumber
            });

            if (response.status === 200) {
                console.log("OTP has been sent on Mobile Number: ", profileInfo.mobileNumber);
                
                toast.success("OTP has been sent on Mobile Number: " + profileInfo.mobileNumber);
                setPhoneTimer(16);
                setShowPhoneOtpInput(true);
            } else {
                toast.error('Failed to verify phone number');
            }
        } catch (error) {
            toast.error(error);
        }
    };

    const handleVerifyEmailOtp = async () => {
        try {
            const response = await axios.post(`${API_URL}/api/v1/auth/verify-email-otp`, {
                email: newEmail,
                otp: Number(emailOtp)
            });

            if (response.status === 200) {
                toast.success('Email verified successfully');
                setEmailVerified(true);
                console.log("----",response.data);
                setFormData((prevData) => ({
                    ...prevData,
                    emailVerificationToken: response.data.randomToken,
                    email: newEmail
                }));
                setEmailOtp("")
            } else {
                toast.error('Failed to verify email OTP');
            }
        } catch (error) {
            toast.error(error);
        }
    };

    const handleVerifyPhoneOtp = async () => {
        try {
            const response = await axios.post(`${API_URL}/api/v1/auth/verify-mobile-otp`, {
                contryCode: profileInfo.countryCode,
                mobileNumber: newPhoneNumber,
                otp: Number(phoneOtp)
            });

            if (response.status === 200) {
                console.log("----",response.data);
                toast.success('Phone number verified successfully');
                setPhoneVerified(true);
                setFormData((prevData) => ({
                    ...prevData,
                    mobileVerificationToken: response.data.randomToken,
                    countryCode: profileInfo.countryCode,
                    mobileNumber: newPhoneNumber
                }));
                setPhoneOtp("")
                
            } else {
                toast.error('Failed to verify phone OTP');
            }
        } catch (error) {
            toast.error(error);
        }
    };

const handleSubmit = async (e) => {
        e.preventDefault();
        // const token = localStorage.getItem('token');
        const token = getCookie("token");
        if (!token) {
            console.log("Not Authorize");
            return;
        }

        // handlePasswordChange();
    };

    const handleEditConfirmation = () => {
        setShowConfirmationModal(true);
    };

    const handleCancelEdit = () => {
        setShowConfirmationModal(false);
    };


    
    const handleProfileSubmit = async () => {
        
        try {
            if(fileupload){
                    formData.profileImageUrl = await uploadImagetos3(fileupload);
            }
            // const token = localStorage.getItem('token');
            const token = getCookie("token");
            console.log("Profile update ",formData)
            const response = await axios.patch(
                `${API_URL}/api/v1/users/profile`,
                formData,
                {
                    headers: {
                        "Content-Type": "application/json",
                        "Authorization": `Bearer ${token}`,
                    },
                }
            );

            if (response.status === 200) {
                toast.success('Profile updated successfully');
                if (newEmail){
                    toast.success('Profile updated successfully, Your email was updated. You will be logged out. Login to continue again');
                    localStorage.clear();
                    window.location.reload()
                    navigate('/')
                }
                setShowConfirmationModal(false);
                fetchProfile(); // Refresh profile data
                setActiveTab("profile")
            } else {
                toast.error('Failed to update profile');
            }
        } catch (error) {
            toast.error(error);
        }
    };
    return (
        <div className="container mt-2">
            <Toaster position='top-right' reverseOrder={false} />
            <div className="row">
                <div className="col-md-12">
                    <h5 className='fw-bold fs-4 border-bottom py-2'>
                        <Icon icon="material-symbols:arrow-back-rounded" className="me-2 cursor-pointer" onClick={() =>  setActiveTab("profile")} />
                        Edit Profile
                    </h5>
                    {/* Profile Photo */}
                    <h6 className='fs-5 text-secondary pt-3'>Profile Photo</h6>
                    <div className='d-flex align-items-center position-relative'>
                        <img src={ profileImg} alt="profile" className='img-fluid profile rounded-circle'
                        />
                        <span className='profile-edit position-absolute' onClick={handleEditClick}>
                            <Icon icon="material-symbols:edit" className="fs-5 text-white" />

                        </span>
                        {/* File input moved outside of span */}
                        <input
                            type="file"
                            ref={fileInputRef}
                            style={{ display: "none" }}
                            accept="image/*"
                            onChange={handleImageChange}
                        />
                    </div>

                    <div className="row">
                        <div className="col-md-10 mt-5">
                            <h5 className='fw-bold fs-5 text-secondary mb-3'>Account Information</h5>
                            {/* First & Last Name */}
                            <div className="d-flex gap-4">
                                <div className="col-md-6 position-relative">
                                    <label className="form-label text-secondary">First Name*</label>
                                    <input
                                        value={formData.firstName } 
                                        type="text"
                                        className="form-control ps-5 rouned-3 "
                                        placeholder={profileInfo.firstName}
                                        onChange={(e) => setFormData({ ...formData, firstName: e.target.value })}
                                        required />
                                    <Icon icon="teenyicons:user-outline" className="fs-5 position-absolute"
                                        style={{ left: '15px', top: '65%', transform: 'translateY(-50%)', color: '#c3c3c3' }} />
                                </div>
                                <div className="col-md-6 position-relative">
                                    <label className="form-label text-secondary">Last Name*</label>
                                    <input
                                        type="text"
                                        value={formData.lastName}
                                        onChange={(e) => setFormData({ ...formData, lastName: e.target.value })}
                                        className="form-control ps-5 rouned-3"
                                        placeholder={profileInfo.lastName}
                                        required />
                                    <Icon icon="teenyicons:user-outline" className="fs-5 position-absolute"
                                        style={{ left: '15px', top: '65%', transform: 'translateY(-50%)', color: '#c3c3c3' }} />
                                </div>
                            </div>
                            {/* Email & Verify Button */}
                            <div className="d-flex gap-4 mt-3">
                                <div className="col-md-6 position-relative">
                                    <label className="form-label text-secondary">Email Id*</label>
                                    <input
                                        type="email"
                                        className="form-control ps-5 rouned-3"
                                        // placeholder={newEmail? newEmail: profileInfo.email}
                                        value={newEmail??profileInfo.email}
                                        onChange={handleEmailChange}
                                        // onFocus={handleEmailChange}
                                        onBlur={handleEmailBlur} 
                                        required />
                                    <Icon icon="bi:envelope" className="fs-5 position-absolute"
                                        style={{ left: '15px', top: '65%', transform: 'translateY(-50%)', color: '#c3c3c3' }} />
                                </div>
                                <div className="col-md-4 py-2 d-flex align-items-end">

                                    {emailVerified ? (
                                        <span className="text-success">Verified</span>
                                    ) : emailTimer > 0 ? (
                                        <button className='reg-btn btn-green px-5 rounded-pill py-2' disabled>Resend OTP ({emailTimer}s)</button>
                                    ) : (
                                        <button className='reg-btn btn-green px-5 rounded-pill py-2' onClick={handleVerifyEmail}>Verify</button>
                                    )}
                                </div>
                            </div>
                            {showEmailOtpInput && !emailVerified && (
                                <div className="d-flex gap-4 mt-3">
                                    <div className="col-md-6 position-relative">
                                        <label className="form-label text-secondary">Enter OTP*</label>
                                        <input
                                            type="text"
                                            inputMode="numeric"
                                            className="form-control ps-5 rouned-3"
                                            value={emailOtp}
                                            onChange={(e) => setEmailOtp(e.target.value)}
                                            required />
                                    </div>
                                    <div className="col-md-4 py-2 d-flex align-items-end">
                                        <button className='reg-btn btn-green px-5 rounded-pill py-2' onClick={handleVerifyEmailOtp}>Verify OTP</button>
                                    </div>
                                </div>
                            )}
                            {/* Phone Number & Verify Button */}
                            <div className="d-flex gap-4 mt-3">
                                <div className="col-md-6 position-relative">
                                    <label className="form-label text-secondary">Phone No*</label>
                                    <input
                                        type="text"
                                        className="form-control ps-5 rounded-3"
                                        // placeholder={profileInfo.mobileNumber}
                                        value={newPhoneNumber??profileInfo.mobileNumber}
                                        onChange={handlePhoneNumberChange}
                                        onBlur={handlePhoneNumberBlur}
                                        required />
                                    <Icon icon="mdi:phone" className="fs-5 position-absolute"
                                        style={{ left: '15px', top: '65%', transform: 'translateY(-50%)', color: '#c3c3c3' }} />
                                </div>
                                <div className="col-md-4 d-flex  py-2 align-items-end">
                                    {phoneVerified ? (
                                        <span className="text-success">Verified</span>
                                    ) : phoneTimer > 0 ? (
                                        <button className='reg-btn btn-green px-5 rounded-pill py-2' disabled>Resend OTP ({phoneTimer}s)</button>
                                    ) : (
                                        <button className='reg-btn btn-green px-5 rounded-pill py-2' onClick={handleVerifyPhoneNumber}>Verify</button>
                                    )}
                                </div>
                            </div>
                            {showPhoneOtpInput && !phoneVerified && (
                                <div className="d-flex gap-4 mt-3">
                                    <div className="col-md-6 position-relative">
                                        <label className="form-label text-secondary">Enter OTP*</label>
                                        <input
                                            type="text"
                                            inputMode="numeric"
                                            className="form-control ps-5 rounded-3"
                                            value={phoneOtp}
                                            onChange={(e) => setPhoneOtp(e.target.value)}
                                            required />
                                    </div>
                                    <div className="col-md-4 py-2 d-flex align-items-end">
                                        <button className='reg-btn btn-green px-5 rounded-pill py-2' onClick={handleVerifyPhoneOtp}>Verify OTP</button>
                                    </div>
                                </div>
                            )}

                            <div className="mt-3">
                                {/* Password Input Row */}
                                <div className="d-flex gap-4 align-items-center">
                                    {/* Enter Password */}
                                    <div className="col-md-6 position-relative">
                                        <label className="form-label text-secondary">Old Password*</label>
                                        <input
                                            type={showPassword ? 'text' : 'password'}
                                            className='form-control ps-5 rounded-3'
                                            value={formData.currentPassword }
                                        placeholder={profileInfo.currentPassword}
                                        onChange={(e) => setFormData({ ...formData, currentPassword: e.target.value })}
                                        required 
                                        />
                                        <Icon icon='mdi:password-outline'
                                            className='fs-5 text-secondary'
                                            style={{
                                                position: 'absolute',
                                                top: '40px',
                                                left: '15px'
                                            }}
                                        />
                                        <Icon icon={showPassword ? 'mdi:eye-off' : 'hugeicons:view'}
                                            className='fs-5 text-secondary cursor-pointer'
                                            style={{
                                                position: 'absolute',
                                                top: '40px',
                                                right: '5%'
                                            }}
                                            onClick={() => setShowPassword(!showPassword)}
                                        />
                                    </div>

                                    {/* Change Password (Toggles new password fields) */}
                                    <div className="col-md-4 d-flex align-items-end">
                                        <button className='fs-6 fw-medium lh-sm py-2 border-0 cursor-pointer'
                                            style={{
                                                color: '#371300',
                                                backgroundColor: 'white'
                                            }}
                                            onClick={handleChangePassword}>
                                            Change Password
                                        </button>
                                    </div>
                                </div>

                                {/* New Password & Confirm Password (Visible below Change Password when clicked) */}
                                {showPasswordFields && (
                                    <div className="mt-3">
                                        {/* New Password */}
                                        <div className="col-md-6 position-relative">
                                            <label className="form-label text-secondary">New Password*</label>
                                            <input
                                                type={showNewPassword ? 'text' : 'password'}
                                                className='form-control ps-5 rounded-3'
                                                placeholder='Enter New Password'
                                                // onChange={(e) => setNewPassword(e.target.value)}
                                                value={formData.newPassword }
                                        onChange={(e) => setFormData({ ...formData, newPassword: e.target.value })}
                                        required 
                                            />
                                            <Icon icon='mdi:password-outline'
                                                className='fs-5 text-secondary'
                                                style={{
                                                    position: 'absolute',
                                                    top: '40px',
                                                    left: '15px'
                                                }}
                                            />
                                            <Icon icon={showNewPassword ? 'mdi:eye-off' : 'hugeicons:view'}
                                                className='fs-5 text-secondary cursor-pointer'
                                                style={{
                                                    position: 'absolute',
                                                    top: '40px',
                                                    right: '5%'
                                                }}
                                                onClick={() => setShowNewPassword(!showNewPassword)}
                                            />
                                        </div>

                                        {/* Confirm Password */}
                                        <div className="d-flex gap-4 mt-3">
                                            <div className="col-md-6 position-relative ">
                                                <label className="form-label text-secondary">Confirm Password*</label>
                                                <input
                                                    type={showConfirmPassword ? 'text' : 'password'}
                                                    className='form-control ps-5 rounded-3'
                                                    placeholder='Confirm New Password'
                                                    // value={confirmPassword}
                                                    // onChange={(e) => setConfirmPassword(e.target.value)}
                                                    value={formData.confirmPassword }
                                        onChange={(e) => setFormData({ ...formData, confirmPassword: e.target.value })}
                                        required
                                                />
                                                <Icon icon='mdi:password-outline'
                                                    className='fs-5 text-secondary'
                                                    style={{
                                                        position: 'absolute',
                                                        top: '40px',
                                                        left: '15px'
                                                    }}
                                                />
                                                <Icon icon={showConfirmPassword ? 'mdi:eye-off' : 'hugeicons:view'}
                                                    className='fs-5 text-secondary cursor-pointer'
                                                    style={{
                                                        position: 'absolute',
                                                        top: '40px',
                                                        right: '5%'
                                                    }}
                                                    onClick={() => setShowConfirmPassword(!showConfirmPassword)}
                                                />
                                                {passwordError && <small className="text-danger">{passwordError}</small>}
                                            </div>
                                            {/* <div className="col-md-4 py-2 d-flex align-items-end">
                                                <button className='reg-btn btn-green px-5 rounded-pill py-2'
                                                 onClick={handleSubmit}>Submit</button>
                                            </div> */}
                                        </div>

                                    </div>
                                )}
                            </div>
                            {/* Country Select */}
                            {/* <div className="col-md-6 position-relative mt-3">
                                <label className="form-label text-secondary">Country*</label>
                                <select className="form-select ps-5 rounded-3" required>
                                    <option value="India">India</option>
                                    <option value="USA">USA</option>
                                    <option value="Canada">Canada</option>
                                    <option value="UK">UK</option>
                                </select>
                                <Icon icon="mdi:web" className="fs-5 position-absolute"
                                    style={{ left: '15px', top: '70%', transform: 'translateY(-50%)', color: '#c3c3c3' }} />
                            </div> */}
                            {/* Save Button */}
                            <div className="col-md-6 mt-5 mb-4">
                                <button
                                    className='reg-btn btn-green w-md-25 w-100 py-2 rounded-pill '
                                    onClick={handleEditConfirmation}
                                >Save Changes</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {/* Confirmation Modal */}
            {showConfirmationModal && (
                <div className="modal show d-block d-flex justify-content-center align-items-center"
                    style={{
                        boxShadow: '0px 4px 6px 0px #00000026',
                        background: '#000000B2'
                    }}>
                    <div className="modal-dialog">
                        <div className="modal-content pt-4">
                            <div>
                                <Icon icon='material-symbols-light:close'
                                    className='close-btn fs-5'
                                    onClick={handleCancelEdit}>

                                </Icon>
                            </div>
                            <h5 className="pt-4 fw-bold fs-5 px-5">Edit Profile Info Confirmation</h5>
                            <p className='px-5 fw-normal fs-6 '
                                style={{ color: '#606060' }}>Are you sure you want to edit this Profile Info ?<br />
                 This action cannot be undone.</p>
                            <div className="d-flex justify-content-center align-items-center gap-4 mt-4 mb-4">
                                <button className="rounded-5 border cancelbtn px-5 py-1"
                                    onClick={handleCancelEdit}>Cancel</button>
                                <button className="px-5 rounded-5 border py-1"
                                    style={{
                                        background: ' #371300',
                                        color: '#FFFFFF'
                                    }}
                                    onClick={() => {
                                        handleProfileSubmit();
                                    }}
                                >Yes, Edit</button>
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
}

export default EditProfile;